import { render, staticRenderFns } from "./InputCheckBox.vue?vue&type=template&id=12407956&"
import script from "./InputCheckBox.vue?vue&type=script&lang=js&"
export * from "./InputCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports